import clsx, { type ClassValue } from 'clsx';

/** Join class names. Thin wrapper so call sites never import clsx directly. */
export function cn(...values: ClassValue[]): string {
  return clsx(values);
}
